import "core-js/modules/es.object.to-string.js";
import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
var scrollOptions = {
  left: 0,
  top: 0,
  behavior: "smooth"
};
export var ScrollToTop = function ScrollToTop(_ref) {
  var excludeRoutes = _ref.excludeRoutes,
    pathname = useLocation().pathname;
  return useEffect(function () {
    excludeRoutes && (Array.isArray(excludeRoutes) ? excludeRoutes : [excludeRoutes]).some(function (prop) {
      return matchPath(pathname, prop);
    }) || window.scrollTo(scrollOptions);
  }, [excludeRoutes, pathname]), null;
};